import React, { useState } from "react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

const Input = (props) => {
  const {
    name,
    type,
    placeholder,
    autoComplete,
    value,
    options,
    onChange,
    register,
    errors,
    classOverride,
    className,
    required,
    icon,
    defaultValue,
  } = props;

  const [passType, setPassType] = useState("password");
  const togglePasswordVisible = () => {
    setPassType(passType === "password" ? "text" : "password");
  };
  const defaultClass =
    "relative focus:outline-none h-14 px-5 w-80 object-contain bg-inputBg text-black font-medium text-sm rounded-2xl ";
  const inputOptions =
    register && options && errors && name
      ? { ...register(name, options ? options : {}) }
      : null;
  return (
    <>
      <input
        required={required}
        className={classOverride ? className : defaultClass + " " + className}
        type={type === "password" ? passType : type}
        style={{
          border: name && errors && errors[name] ? "0.5px solid #d94436" : "",
        }}
        value={value}
        name={name}
        {...inputOptions}
        placeholder={placeholder}
        autoComplete={autoComplete}
        defaultValue={defaultValue}
        onChange={onChange}
      />
      {name && errors && errors[name] ? (
        <div className=" text-xs font-medium tablet:text-sm w-full pl-4 text-red-600">
          {errors[name].message}
        </div>
      ) : null}
      {icon && (
        <div
          className="absolute cursor-pointer right-4 text-txtGray w-6 h-6 h-full flex flex-row justify-center items-center"
          onClick={togglePasswordVisible}
        >
          {passType === "password" ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        </div>
      )}
    </>
  );
};

export default Input;
